import { Component } from 'react';
import './Summary.css';

class Summary extends Component {
  constructor(props) {
    super(props)
    this.timer = null;
    this.wrapperRef = null;
    this.observer = null;
    this.state = {
      serviceCustomer: 0,
      platformNode: 0,
      upstrameBandwidth: 0,
      started: false,
      done: false
    }
    this.setWrapperRef = this.setWrapperRef.bind(this)
  }
  componentDidMount() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.state.started) {
          this.setState({ started: true });
          this.startCount();
        }
      });
    }, { threshold: 0.5 });
    if (this.wrapperRef) {
      this.observer.observe(this.wrapperRef);
    }
  }
  componentWillUnmount() {
    if (this.timer) clearInterval(this.timer);
    if (this.observer) this.observer.disconnect();
  }
  setWrapperRef(el) {
    this.wrapperRef = el;
  }
  startCount() {
    this.timer = setInterval(() => {
      const { serviceCustomer, platformNode, upstrameBandwidth } = this.state;
      const allDone = serviceCustomer >= 300 && platformNode >= 100000 && upstrameBandwidth >= 10000;
      if (allDone) {
        clearInterval(this.timer);
        this.timer = null;
        this.setState({ done: true });
        return;
      }
      this.setState({
        serviceCustomer: Math.min(serviceCustomer + 15, 300),
        platformNode: Math.min(platformNode + 5000, 100000),
        upstrameBandwidth: Math.min(upstrameBandwidth + 500, 10000)
      });
    }, 80);
  }
  render() {
    return (
    <div className="summary wow fadeInLeft" ref={this.setWrapperRef}>
        <div className={`summary-item wow fadeIn${this.state.done ? ' done' : ''}`} data-wow-duration="3s" data-wow-delay="0.5s">
          <div className='summary-item-number-wrap'>
            <p className='summary-item-number'>{ this.state.serviceCustomer }+</p>
            <div className='summary-item-glow'></div>
          </div>
          <p className='summary-item-sub-titile'>服务客户</p>
        </div>
        <div className={`summary-item wow fadeIn${this.state.done ? ' done' : ''}`} data-wow-duration="3s" data-wow-delay="0.5s">
          <div className='summary-item-number-wrap'>
            <p className='summary-item-number'>{ this.state.platformNode }+</p>
            <div className='summary-item-glow'></div>
          </div>
          <p className='summary-item-sub-titile'>平台节点</p>
        </div>
        <div className={`summary-item wow fadeIn${this.state.done ? ' done' : ''}`} data-wow-duration="3s" data-wow-delay="0.5s">
          <div className='summary-item-number-wrap'>
            <p className='summary-item-number'>{ this.state.upstrameBandwidth }G+</p>
            <div className='summary-item-glow'></div>
          </div>
          <p className='summary-item-sub-titile'>上行带宽</p>
        </div>
    </div>
  );
  }
}

export default Summary;
